import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Route, Switch } from "react-router-dom";
import { getTaskAdminBasePath, getTaskAdminBaseRoute, } from "../AdminTaskRoutes";
import TaskTemplateCreate from "../../../../../../components/taskAdmin/taskTemplates/taskTemplateCreate";
import TaskTemplateEdit from "../../../../../../components/taskAdmin/taskTemplates/taskTemplateEdit";
import TaskTemplateDetail from "../../../../../../components/taskAdmin/taskTemplates/taskTemplateDetail";
import TaskTemplateIndex from "../../../../../../components/taskAdmin/taskTemplates/taskAdminIndex";
// Paths
export const getTaskAdminTemplateBasePath = () => `${getTaskAdminBasePath()}/template`;
export const getTaskAdminTemplateCreatePath = () => `${getTaskAdminTemplateBasePath()}/create`;
export const getTaskAdminTemplateEditPath = (id) => `${getTaskAdminTemplateBasePath()}/edit/${id}`;
export const getTaskAdminTemplateDetailsPath = (id) => `${getTaskAdminTemplateBasePath()}/${id}`;
// Routes
export const getTaskAdminTemplateBaseRoute = () => `${getTaskAdminBaseRoute()}/template`;
export const getTaskAdminTemplateCreateRoute = () => `${getTaskAdminTemplateBaseRoute()}/create`;
export const getTaskAdminTemplateEditRoute = () => `${getTaskAdminTemplateBaseRoute()}/edit/:templateId`;
export const getTaskAdminTemplateDetailsRoute = () => `${getTaskAdminTemplateBaseRoute()}/:templateId`;
const AdminTaskTemplateRoutes = () => {
    return (_jsxs(Switch, { children: [_jsx(Route
            // @ts-expect-error - TS2769 - No overload matches this call.
            , { 
                // @ts-expect-error - TS2769 - No overload matches this call.
                component: TaskTemplateCreate, path: getTaskAdminTemplateCreateRoute() }), _jsx(Route, { component: TaskTemplateEdit, path: getTaskAdminTemplateEditRoute() }), _jsx(Route, { component: TaskTemplateDetail, path: getTaskAdminTemplateDetailsRoute() }), _jsx(Route
            // @ts-expect-error - TS2769 - No overload matches this call.
            , { 
                // @ts-expect-error - TS2769 - No overload matches this call.
                component: TaskTemplateIndex, path: getTaskAdminTemplateBaseRoute() })] }));
};
export default AdminTaskTemplateRoutes;
